export enum AnswerType {
  ANSWER_TYPE_NONE = 1,
  ANSWER_TYPE_FLAG = 2,
  ANSWER_TYPE_CODE = 3,
  ANSWER_TYPE_QUIZ = 4,
  ANSWER_TYPE_UPLOAD = 5,
  ANSWER_TYPE_CONTAINER = 6,
  ANSWER_TYPE_FILE_UPLOAD = 7,
}
